var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4163",
    "data-name": "Rectangle 4163",
    width: 24,
    height: 24,
    transform: "translate(1211 21)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4784",
    "data-name": "Mask Group 4784",
    transform: "translate(-1211 -21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g969",
    transform: "translate(1215.5 708.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g971",
    transform: "translate(-1.485 -684.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7778",
    "data-name": "Group 7778",
    transform: "translate(0.586 0.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path981",
    d: "M0-306.266a8.4,8.4,0,0,0,8.4,8.4,8.4,8.4,0,0,0,8.4-8.4,8.4,8.4,0,0,0-8.4-8.4A8.4,8.4,0,0,0,0-306.266Z",
    transform: "translate(0 314.666)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g983",
    transform: "translate(5.659 2.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path985",
    d: "M-197.256-98.628a2.705,2.705,0,0,1-2.705,2.705,2.705,2.705,0,0,1-2.705-2.705,2.705,2.705,0,0,1,2.705-2.705A2.705,2.705,0,0,1-197.256-98.628Z",
    transform: "translate(202.666 101.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g987",
    transform: "translate(4.519 10.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path989",
    d: "M-288.2-60.994a4.551,4.551,0,0,0-3.53-1.673h-.845a4.552,4.552,0,0,0-3.53,1.673",
    transform: "translate(296.103 62.667)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/UserLogo.147f8363b761bbcbe01823d6b2f9a0c7.svg";
export { ForwardRef as ReactComponent };